import { CalculationWithOverviewResponse } from '@ydistri/api-sdk';

export const ICON_SIZE_COMPACT = 18;
export const ICON_SIZE_NORMAL = 24;
export const ICON_SIZE_BIG = 26;

export const emptyCalculationsWithOverviewResponse: CalculationWithOverviewResponse[] = [];
